
import XDialog from 'vux/src/components/x-dialog/index.vue'

import CheckIcon from 'vux/src/components/check-icon/index.vue'

export default {
components: {
XDialog,
CheckIcon
},
data() {
return {
isAgree: true

};
},
computed: {
pcLoginShow() {
return this.$store.state.pcLoginShow;
}
},
watch: {
pcLoginShow(newVal) {
this.generateWechatLoginQRcode();
}
},
methods: {





generateWechatLoginQRcode() {
let that = this;
let currentUrl = location.href.split('#')[0];
that.getWeiXinConfig(function(weiXinConfig) {
console.log(weiXinConfig);

var redirect_uri = encodeURIComponent(sessionStorage.domainURL + '/LonBonStore/#/mallHomepage');
var obj = new WxLogin({
self_redirect: false,
id: 'login_container',
appid: 'wx147a2dc903fdb669', // weiXinConfig.appId
scope: 'snsapi_login',
redirect_uri: redirect_uri,
state: Math.ceil(Math.random() * 1000),
style: 'black',
href:
'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKIGRpc3BsYXk6IG5vbmU7Cn0KLmltcG93ZXJCb3ggLnN0YXR1cy5zdGF0dXNfYnJvd3NlciB7CiBkaXNwbGF5OiBub25lOwp9Ci5pbXBvd2VyQm94IC5xcmNvZGUgewogYm9yZGVyOiBub25lOwp9Ci5pbXBvd2VyQm94IC5zdGF0dXN7CiBkaXNwbGF5OiBub25lICFpbXBvcnRhbnQ7Cn0='
});
}, currentUrl);
},

getWeiXinConfig(callback, url_) {
let that = this;
that.$axios
.get('/api/v1.0/weChatPublicSignature', {
params: {
url: url_
}
})
.then(function(response) {
if (response.status == 200) {
var weiXinConfig = response.body;
callback && callback(weiXinConfig);
}
});
}
},
mounted() {










}
};



// WEBPACK FOOTER //
// ./src/pcComponents/home/wxLogin.vue